import React, { lazy } from 'react'

const QuestionnairePage = lazy(() => import('./QuestionnairePage'))

export { QuestionnairePage }
